import Configurator from './Configurator.vue';

export default Configurator;
